import axios from "axios";

const producao =
  window.location.href.indexOf("app.motorfiscal") != -1 ? true : false;
const url = producao
  ? "https://apiv2.motorfiscal.com.br"
  : "https://apiv2homolog.motorfiscal.com.br";

export async function getInformeRendimentosApi(
  dataIni,
  dataFim,
  tipo,
  statusArquivo,
  statusEmail,
  token
) {
  try {
    const response = await axios.get(
      `${url}/informe-rendimento-pdf?dataIni=${dataIni}&dataFim=${dataFim}&tipo=${tipo}&statusArquivo=${statusArquivo}&statusEmail=${statusEmail}`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    return null;
  }
}

export async function informeRendimentosUploadFileApi(json, token) {
  try {
    const response = await axios.post(`${url}/informe-rendimento-pdf`, json, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return response.data;
  } catch (err) {
    return null;
  }
}

export async function informeRendimentosBuscaArquivoApi(id, token) {
  try {
    const response = await axios.get(
      `${url}/informe-rendimento-baixa-pdf/${id}`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/pages/loggedArea/informeRendimentos/InformeRendimentosService.js